export const updateCurrentStatusWidgetReducer = (state, action) => {
    const { sectionId, widget, widgetStatus } = action.payload;
    const componentProps = widget?.componentProps;
    if (!widget.id || !componentProps || !componentProps.userSettings) {
        return;
    }
    const currentStatusWidgets = state.currentStatus.sections?.[sectionId]?.widgets;
    if (currentStatusWidgets?.[widget.id]) {
        Object.assign(currentStatusWidgets[widget.id], {
            chartSeriesTypes: componentProps.chartSeriesTypes,
            chartType: componentProps.chartType,
            customDateRangeEndDate: widgetStatus?.customDateRangeEndDate ?? componentProps.userSettings.customDateRangeEndDate,
            customDateRangeStartDate: widgetStatus?.customDateRangeStartDate ?? componentProps.userSettings.customDateRangeStartDate,
            dataGranularity: componentProps.userSettings.dataGranularity,
            dataGranularityTitle: componentProps.userSettings.dataGranularityTitle,
            dataScale: componentProps.userSettings.dataScale,
            defaultTenor: componentProps.userSettings.defaultTenor,
            displayOptions: componentProps.userSettings.displayOptions,
            displayValueType: componentProps.userSettings.displayValueType,
            excludeSoldAssets: componentProps.userSettings.excludeSoldAssets,
            gridSwitch: componentProps.userSettings.gridSwitch,
            hasDatePicker: componentProps.userSettings.hasDatePicker,
            periodOfAnalysis: componentProps.userSettings.periodOfAnalysis?.defaultValue,
            selectedValues: componentProps.selectedValues,
            shownValues: componentProps.userSettings.shownValues,
            sortBy: componentProps.userSettings.sortBy,
            viewForm: componentProps.userSettings.viewForm,
            viewFormExclude: componentProps.userSettings.viewFormExclude
        });
    }
};
